import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { Profession } from 'src/app/shared/models/lookup-profession.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ProfessionsService {
    private readonly coreApiPath: string;

    constructor(
        private readonly http: HttpClient,
        @Inject(APP_CONFIG) settings: Settings
    ) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova/common');
    }

    getProfessions(): Observable<Profession[]> {
        return this.http.get<Profession[]>(`${this.coreApiPath}/professions`);
    }
}
